

























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import { TbGoodsClass, TbShopAccount, TbMember } from "@/http";
import  dialogPanel  from "./dialogPanel.vue"
import dayjs from 'dayjs';
 @Component({
    components: {dialogPanel},
}) 
export default class addByjPanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:false
    })
    show:Boolean;

    title="输入备用金";

    isloading=false;
    isloading2=false;

    awidth = '63.21vw';

    form:any={
        money:0,
    }
    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }

    value=null;
    maxLength=10;

    userInfo:any={};



    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
        this.value = this.form.money;
    }
    async created() {
    
    }

    resetForm(){
       this.form={
            money:0
       } 
    }
  
    closeFun(){
        this.resetForm();
        this.$emit("closeFun");
    }

    del() {
		if(!this.value) return;
        let index = this.value.length;
        this.value = this.value.toString().slice(0,index-1);
        this.finishFun();
    }
	numbernew(number) {
		// this.$emit("number", number);
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}


	clearFun(){
            this.value = null;
            this.finishFun();
    }
    finishFun(){
        this.form.money = this.value;
    }
    async confirmByj(){
        if(this.isloading2) return;
        try {
            this.isloading2 = true;
            let res = await TbShopAccount.AddTbImprest({
                handoverId:JSON.parse(localStorage.getItem("padUserinfo")).id,
                money:Number(this.form.money)
            });
            this.closeFun();
            setTimeout(() => {
                this.isloading2 = false;
            }, 500);
            
        }catch {
            setTimeout(() => {
                this.isloading2 = false;
            }, 500);
        }
        
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/addByjPanel.vue